"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LogoCircleMe = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

/**
 * The JOBMATCH.ME Circle Logo
 *
 * @param {width}         size  Logo width
 * @param {height}        size  Logo height
 * @param {background}    color Background color
 * @param {primary}       color Primary color
 * @param {secondary}     color Secondary color
 *
 **/
var LogoCircleMe = function LogoCircleMe(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '100' : _ref$height,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? '#3ecd84' : _ref$background,
      _ref$primary = _ref.primary,
      primary = _ref$primary === void 0 ? '#004324' : _ref$primary,
      _ref$secondary = _ref.secondary,
      secondary = _ref$secondary === void 0 ? '#ffed00' : _ref$secondary;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "logoJMM",
    width: width,
    height: height,
    viewBox: "0 0 950.578 952.551",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(17712 487)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(-17712 -487)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          width: "950.579",
          height: "952.551",
          rx: "475.289",
          transform: "translate(0 0)",
          fill: background
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M-17527.811-59.255h-80.459V-344.5h45.467l110.422,136.176,109.137-136.176h44.773V-59.255h-80.051V-176.713l-59.359,70.637h-29.627l-60.3-70.637Z",
        transform: "translate(135.801 186.562)",
        fill: primary
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M-17454.846-59.608V-344.232h226.887v70.247h-147.428v38.89h123.426v66.829h-123.426v39.827h147.428v68.831Z",
        transform: "translate(336.675 186.914)",
        fill: primary
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        cx: "48.5",
        cy: "48.5",
        r: "48.5",
        transform: "translate(-17611 26.051)",
        fill: secondary
      })]
    })
  });
};

exports.LogoCircleMe = LogoCircleMe;

var _default = /*#__PURE__*/_react.default.memo(LogoCircleMe);

exports.default = _default;